// Mail provider IDs are opaque routing inputs. Keep the exact pair intact so
// colliding provider message IDs can never share a cache or rendered row.
export const emailSourceKey = ({ emailId, mailIntegrationId } = {}) => (
  JSON.stringify([mailIntegrationId ?? null, emailId ?? null])
);
